export default __webpack_public_path__ + "static/media/Hyrkanian Dread Ash-Tramper.5e8164aa.jpg";